import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data, SelectTimeSlotData } from "../../../utils/common";

export const AllPermmission = createAsyncThunk(
  "common/masters/all-permission",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPermmission);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllRoles = createAsyncThunk(
  "common/masters/all-role",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllRoles}?name=${filter}`);

      return await Select2Data(res.data, "role_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Country - Get All
export const AllCountry = createAsyncThunk(
  "common/masters/all-country",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCountry}?name=${filter}`);

      return await Select2Data(res.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// State - Get All (for a specific country)
export const AllState = createAsyncThunk(
  "common/masters/all-state/:id",
  async ({ countryId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllState}/${countryId}?name=${name}`
      );

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// City - Get All (for a specific state)
export const AllCity = createAsyncThunk(
  "common/masters/all-city/:id",
  async ({ stateId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCity}/${stateId}?name=${name}`);
      return await Select2Data(res.data, "city_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Cities = createAsyncThunk(
  "common/masters/city",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.Cities}?name=${filter}`);

      return await Select2Data(res.data, "city_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Pincode - Get All (for a specific city)
export const AllPincode = createAsyncThunk(
  "common/masters/all-pincode/:id",
  async ({ cityId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPincode}/${cityId}?name=${name}`
      );
      return await Select2Data(res.data, "pincode_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Country - Get All
export const AllAccountStatus = createAsyncThunk(
  "common/masters/all-account-status",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllAccountStatus}?name=${filter}`);
      return await Select2Data(res.data.data, "account_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllVerificationStatus = createAsyncThunk(
  "common/masters/all-verification-status",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllVerificationStatus}?name=${filter}`
      );
      // return res;
      return await Select2Data(res.data.data, "account_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllCategory = createAsyncThunk(
  "common/masters/all-category-status",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCategory}?name=${filter}`);
      // return res;
      return await Select2Data(res.data.data, "account_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllVehicleCategory = createAsyncThunk(
  "common/masters/all-vehicle-category-type",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllVehicleCategory}?name=${filter}`
      );
      // return res;
      return await Select2Data(res.data, "vehicle_category_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllServiceCenter = createAsyncThunk(
  "common/masters/all-service-center",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllServiceCenter}?name=${filter}`);

      return await Select2Data(res.data, "service_center_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllAmbassadorNew = createAsyncThunk(
  "common/masters/all-ambassador-new",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllAmbassadorNew}?name=${filter}`);

      return await Select2Data(res.data, "ambassador_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllvehicleType = createAsyncThunk(
  "common/masters/all-vehicle-type",
  async (
    { category_id = "", vehicle_category_id = "" },
    { rejectWithValue }
  ) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllVehicleType}?category_id=${category_id}&vehicle_category_id=${vehicle_category_id}`
      );

      return await Select2Data(res.data, "vehicle_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllAmbassador = createAsyncThunk(
  "common/masters/all-ambassador",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllAmbassador}?name=${filter}`);

      return await Select2Data(res.data, "ambassador_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllTimeSlots = createAsyncThunk(
  "common/masters/all-time-slots",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTimeSlots}?name=${filter}`);

      return await SelectTimeSlotData(res.data, "time_slot_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllTimeSlotsAdmin = createAsyncThunk(
  "common/masters/all-time-slots-admin",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTimeSlotsAdmin}?name=${filter}`);

      return await SelectTimeSlotData(res.data, "time_slot_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllUserStatus = createAsyncThunk(
  "common/masters/all-user-status",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllUserStatus}?name=${filter}`);

      return await Select2Data(res.data, "user_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllWithdrawStatus = createAsyncThunk(
  "common/masters/all-withdraw-status",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllWithdrawStatus}?name=${filter}`);

      return await Select2Data(res.data, "withdraw_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllTransactionType = createAsyncThunk(
  "common/masters/all-transaction-type",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllTransactionType}?name=${filter}`
      );

      return await Select2Data(res.data, "transaction_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllTypes = createAsyncThunk(
  "common/masters/all-types",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllType}?name=${filter}`);

      return await Select2Data(res.data, "type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllServiceTypes = createAsyncThunk(
  "common/masters/all-service-type",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllServiceType}?name=${filter}`);

      return await Select2Data(res.data, "service_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "common",
  initialState: {
    all_country: [],
    all_state: [],
    all_city: [],
    city: [],
    all_pincode: [],
    all_permission: {},
    all_roles: [],
    all_account_status: [],
    all_verification_status: [],
    all_category: [],
    all_vehicle_category: [],
    all_service_center: [],
    all_ambassador_new: [],
    all_vehicle_type: [],
    all_ambassador: [],
    all_time_slots: [],
    all_time_slots_admin: [],
    all_user_status: [],
    all_withdraw_status: [],
    all_transaction_type: [],
    all_type: [],
    all_service_type: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(AllCountry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCountry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_country = action.payload || [];
      })
      .addCase(AllCountry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_state = action.payload || [];
      })
      .addCase(AllState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_city = action.payload || [];
      })
      .addCase(AllCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Cities.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Cities.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.city = action.payload || [];
      })
      .addCase(Cities.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllPincode actions
      .addCase(AllPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_pincode = action.payload || [];
      })
      .addCase(AllPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPermmission.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPermmission.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        state.all_permission = action.payload || {};
      })
      .addCase(AllPermmission.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;

        state.error = action.payload;
      })

      .addCase(AllRoles.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllRoles.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        state.all_roles = action.payload || [];
      })
      .addCase(AllRoles.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;

        state.error = action.payload;
      })

      .addCase(AllAccountStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAccountStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_account_status = action.payload || [];
      })
      .addCase(AllAccountStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllVerificationStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllVerificationStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_verification_status = action.payload || [];
      })
      .addCase(AllVerificationStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_category = action.payload || [];
      })
      .addCase(AllCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllVehicleCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllVehicleCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_vehicle_category = action.payload || [];
      })
      .addCase(AllVehicleCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllServiceCenter.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllServiceCenter.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_service_center = action.payload || [];
      })
      .addCase(AllServiceCenter.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllAmbassadorNew.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAmbassadorNew.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_ambassador_new = action.payload || [];
      })
      .addCase(AllAmbassadorNew.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllvehicleType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllvehicleType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_vehicle_type = action.payload || [];
      })
      .addCase(AllvehicleType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllAmbassador.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAmbassador.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_ambassador = action.payload || [];
      })
      .addCase(AllAmbassador.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTimeSlots.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTimeSlots.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_time_slots = action.payload || [];
      })
      .addCase(AllTimeSlots.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTimeSlotsAdmin.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTimeSlotsAdmin.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_time_slots_admin = action.payload || [];
      })
      .addCase(AllTimeSlotsAdmin.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllUserStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllUserStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_user_status = action.payload || [];
      })
      .addCase(AllUserStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllWithdrawStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllWithdrawStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_withdraw_status = action.payload || [];
      })
      .addCase(AllWithdrawStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTransactionType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTransactionType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_transaction_type = action.payload || [];
      })
      .addCase(AllTransactionType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTypes.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTypes.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_type = action.payload || [];
      })
      .addCase(AllTypes.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllServiceTypes.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllServiceTypes.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_service_type = action.payload || [];
      })
      .addCase(AllServiceTypes.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
